// extracted by mini-css-extract-plugin
module.exports = {"toast":"ToastComponent_toast__3EMjQ","success":"ToastComponent_success__3Fr8F","error":"ToastComponent_error__ge32I"};